(function ($) {
    $(document).ready(function () {
        var mediaSmartphone = 'mediaSmartphone',
            mediaTablet = 'mediaTablet',
            mediaDesktop = 'mediaDesktop';

        var jRes = jRespond([
            {
                label: 'smartphone',
                enter: 0,
                exit:  767
            }, {
                label: 'tablet',
                enter: 768,
                exit:  1279
            }, {
                label: 'desktop',
                enter: 1280,
                exit:  10000
            }
        ]);

        jRes.addFunc([
            {
                breakpoint: 'smartphone',
                enter:      function () {
                    myInitFuncSmartphone();

                },
                exit:       function () {
                }
            },
            {
                breakpoint: 'tablet',
                enter:      function () {
                    myInitFuncTablet();

                },
                exit:       function () {
                }
            },
            {
                breakpoint: 'desktop',
                enter:      function () {
                    myInitFuncDesktop();

                },
                exit:       function () {
                }
            }
        ]);

        function myInitFuncSmartphone() {
            fancyboxGalerie(mediaSmartphone); // 230_stratis_fancybox_galerie.js
            initGalerieClassique(mediaSmartphone); // 240_ stratis_galerie_classique.js
            searchState(mediaSmartphone); // 290_stratis_search.js
            filtersState(mediaSmartphone); // 300_stratis_filters.js
            carrousel1State(mediaSmartphone); // 330_stratis_carrousel1.js
            //carrousel2State(mediaSmartphone); // 340_stratis_carrousel2.js
            menuMain1(mediaSmartphone); // 190_stratis_menu-main-1.js
        }

        function myInitFuncTablet() {
            fancyboxGalerie(mediaTablet); // 230_stratis_fancybox_galerie.js
            initGalerieClassique(mediaTablet); // 240_ stratis_galerie_classique.js
            searchState(mediaTablet); // 290_stratis_search.js
            filtersState(mediaTablet); // 300_stratis_filters.js
            carrousel1State(mediaTablet); // 330_stratis_carrousel1.js
            //carrousel2State(mediaTablet); // 340_stratis_carrousel2.js
            menuMain1(mediaTablet); // 190_stratis_menu-main-1.js
        }

        function myInitFuncDesktop() {
            fancyboxGalerie(mediaDesktop); // 230_stratis_fancybox_galerie.js
            initGalerieClassique(mediaDesktop); // 240_stratis_galerie_classique.js
            searchState(mediaDesktop); // 290_stratis_search.js
            filtersState(mediaDesktop); // 300_stratis_filters.js
            carrousel1State(mediaDesktop); // 330_stratis_carrousel1.js
            //carrousel2State(mediaDesktop); // 340_stratis_carrousel2.js
            menuMain1(mediaDesktop); // 190_stratis_menu-main-1.js
        }

        // Generic functions
        preloadImages(); // 170_stratis_preload_images.js
        objectFitImages(); // 175_lib_ofi.min.js
        geocode(); // 205_stratis_geocode.js
        linkExternalNewWindow(); // 210_stratis_external_window.js
        fancyboxClassic(); // 220_stratis_fancybox_classic.js
        //fancyboxAutoHome();  // 235_stratis_fancybox_auto_home.js
        sharePage(); // 250_stratis_share_page.js
        eventDdm(); // 260_stratis_event-ddm.js
        contentDdm(); // 270_stratis_content-ddm.js
        manageVideo(); // 280_stratis_video.js
        enableDatePicker(); // 310_stratis_datetimepicker.js
        //enableTimePicker(); // 310_stratis_datetimepicker.js To remove
        formValidation(); // 320_stratis_form_validation.js
        // infiniteScroll(); // 350_stratis_infinite_scroll.js
        showTotal(); // 350_stratis_infinite_scroll.js
        catmenu(); // 355_stratis_catmenu.js
        cookiesManagement(); // 360_stratis_cookies_management.js
        faqDdm(); // 370_stratis_faq.js
        addContentInTitle(); // 380_stratis_add_in_title.js
        //generatePie(); // 390_stratis_piechart.js
        autocomplete(); // 410_autocomplete.js

        $('.js-show-popover').webuiPopover({
            animation:'pop'
        });
    });

    accessTooltipState(); // 400_stratis_access-tooltip.js


    $(document).ready(function () {

        // ObjectFitImafes

        $(function () {
            objectFitImages()
        });

        // Fixed menu open-close
        function fixedMenuToggler() {
            // var fixedMenu = $('.fixed-menu');
            // var fixedMenuInner = fixedMenu.find('.fixed-menu_box');
            //
            // if (!$(fixedMenu).hasClass('fixed-menu--active')) {
            //     $(fixedMenu).addClass("fixed-menu--active");
            //     fixedMenuInner.find('a, select, input, button').attr('tabindex', 0);
            //     $('body').addClass('has-overflow');
            //     $('.fixed-menu-overlay').addClass('is-visible');
            // } else {
            //     $(fixedMenu).removeClass("fixed-menu--active");
            //     fixedMenuInner.find('a, select, input, button').attr('tabindex', -1);
            //     $('body').removeClass('has-overflow');
            //     $('.fixed-menu-overlay').removeClass('is-visible');
            // }
        }

        // if ($('.fixed-menu').length) {
        //     var fixedMenu = $('.fixed-menu');
        //     var fixedMenuInner = fixedMenu.find('.fixed-menu_box');
        //     $('.fixed-menu').before('<div class="fixed-menu-overlay"></div>');
        //
        //     if (!fixedMenu.hasClass('fixed-menu--active')) {
        //         fixedMenuInner.find('a, select, input, button').attr('tabindex', -1);
        //     }
        // }

        $(".fixed-menu .fixed-menu_opener").click(function(){

            fixedMenuToggler();

            // var text_el = $(this).find('.fixed-menu_text');
            // text_el.text(function(i, text) {
            //     return text === "Réduit En 1 clic" ? "Votre commune, vos services" : "Votre commune, vos services";
            // });
            // var text_e = $(this).find('.fixed-menu_opener');
            // text_e.attr(function(i, text){
            //     text.attr('title', 'Votre commune, vos servicesgu');
            // });
        });


        // close right menu when last elem ent focused out
        var lastEl = $('.fixed-menu_list li').last().find('a');

        lastEl.on('focusout', function () {
            fixedMenuToggler();
        });

        $('.fixed-menu-overlay').click(function () {
            fixedMenuToggler();

            // var text_el = $(this).next().find('.fixed-menu_text');
            // text_el.text(function(i, text) {
            //     return text === "Réduit En 1 clic" ? "Développé En 1 clic" : "Réduit En 1 clic";
            // });
            // var text_e = $(this).next().find('.fixed-menu_opener');
            // text_e.attr(function(i, text){
            //     text.attr('title', 'Développé En 1 clic');
            // });
        });

        var cutElement = $('.js-cut-to-title');
        var pasteElement = $('.page-title');

        if (cutElement.length) {
            pasteElement.wrap('<div class="page-title-wrapper"></div>');
            pasteElement.parent().append(cutElement);
        }

        $(".fancybox-video").fancybox({
            helpers : {
                media : {}
            }
        });


        // Slick-slider

        $('.our-sites__slick-slider').slick({
            infinite: true,
            speed: 800,
            // autoplay: true,
            // cssEase: 'linear',
            lazyLoad: 'ondemand',
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.kiosque__slick-slider').slick({
            infinite: true,
            speed: 800,
            // autoplay: true,
            cssEase: 'linear',
            lazyLoad: 'ondemand',
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

    $(window).on('load', function () {
        var $list = $('.social-list'),
            $filterBtns = $('.filter-social [data-filter]');
        $list.isotope({
            itemSelector: 'li',
            masonry: {}
        });
        filter('.social-list-item--display');
        toggleActive($filterBtns.eq(0));
        $('.filter-social').on('click', 'a', function (e) {
            e.preventDefault();
            var $elem = $(this);
            filter($elem.attr('data-filter'));
            toggleActive($elem);
        });
        function filter(val) {
            $list.isotope({
                filter: val
            });
        }
        function toggleActive($elem) {
            deactivateAll();
            makeActive($elem);
        }
        function makeActive($elem) {
            $elem.addClass('active');
        }
        function deactivateAll() {
            $filterBtns.removeClass('active');
        }
    });

    var stickHeader = $('.js-sticky');
    stickHeader.after('<div class="js-sticky-clone"></div>');
    stickHeader.addClass('sticky-active');

    var stickClone = $('.js-sticky-clone');
    stickClone.height(stickHeader.height());

    $(window).on('resize', function () {
        stickClone.height(stickHeader.height());
    });

// Socials on home page - Show all by ajax complete.
    $(document).ajaxComplete(function () {
        var $list = $('.social-list');
        $list.isotope({
            filter: '*'
        });

        if ($('#pieChartTarget').is(':empty')) {
            generatePie();
        }
    });

    //fixed heading at scroll

    $(window).on('load', function() {
        // sticky();
    });

    function sticky() {
        var
            $win = $(window),
            $doc = $(document);

        // $('.js-sticky').each(function() {
        //     var
        //         $elem = $(this),
        //         $parent = $elem.parent(),
        //         top = getTopCoord(),
        //         stickyState = false;
        //
        //     $win
        //         .on('resize orientationchange', onResize)
        //         .on('scroll', onScroll);
        //
        //     function getHeight() {
        //         return $elem.outerHeight();
        //     }
        //
        //     function getTopCoord() {
        //         return $parent.offset().top;
        //     }
        //
        //     function setParentHeight() {
        //         $parent.css('height', getHeight());
        //     }
        //
        //     function unsetParentHeight() {
        //         $parent.css('height', '');
        //     }
        //
        //     function checkScroll() {
        //         if (!stickyState &&
        //             $win.scrollTop() > top &&
        //             $win[0].innerWidth > 1279
        //         ) {
        //             activateSticky();
        //         } else if (
        //             stickyState &&
        //             ($win.scrollTop() <= top || $win[0].innerWidth < 1278)
        //         ) {
        //             deactivateSticky();
        //         }
        //     }
        //
        //     function activateSticky() {
        //         stickyState = true;
        //
        //         $elem.addClass('sticky-active');
        //         setParentHeight();
        //
        //         $doc.trigger('stickyActive', [$elem]);
        //     }
        //
        //     function deactivateSticky() {
        //         stickyState = false;
        //
        //         $elem.removeClass('sticky-active');
        //         unsetParentHeight();
        //
        //         $doc.trigger('stickyInactive', [$elem]);
        //     }
        //
        //     function onResize() {
        //         top = getTopCoord();
        //         checkScroll();
        //         stickyState ? setParentHeight() : unsetParentHeight();
        //     }
        //
        //     function onScroll() {
        //         checkScroll();
        //     }
        // });
    }

})(jQuery);

// tabindex enimages
noIndexForImage();

function noIndexForImage() {
    $('.no-index a').attr('tabindex', '-1');
}


(function () {
    var
        $elem = $('.flash-info'),
        cookie = getCookie('flashinfo');
    if (!cookie) {
        $elem.show();
    }
    else {
        $elem.hide();
    }
    $elem.find('.flash-info__btn-close').on('click', onClick);
    function onClick() {
        $elem.hide();
        $(window).resize();
        // setCookie('flashinfo', true, {
        //     expires: 60 * 60 * 24, // week in seconds
        //     path: '/'
        // });
    }
})();
function setCookie(name, value, options) {
    options = options || {};
    var expires = options.expires;
    if (typeof expires === "number") {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }
    value = encodeURIComponent(value);
    var updatedCookie = name + "=" + value;
    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }
    document.cookie = updatedCookie;
}
function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
function deleteCookie(name) {
    setCookie(name, "", {
        expires: -1
    })
}

//text limitation in height > banner > home page
function cropBannerText(contentArray) {
    var limit = 60; //quantity symbols
    var newsContent = $('.banner__info h2');


    newsContent.each(function (index) {
        var text = $(this).text().trim();
        var wrappedText;

        contentArray.push(text);

        if ($(window).width() < 768) {
            if (text.length > limit) {
                wrappedText = text.slice(0, limit) + '...';
                $(this).text(wrappedText);
            }
        } else {
            $(this).text(contentArray[index]);
        }

    });
}

$(document).ready(function () {

    var contentArray = [];
    cropBannerText(contentArray);

    $(window).resize(function () {
        cropBannerText(contentArray);
    });
});

